import React, { useState, createRef, useEffect } from 'react';
import { Map, GeoJSON, Marker, Popup } from 'react-leaflet';
import phuBoundaries from '../../../phuBoundariesSmall.json';
import dict from '../../../dictionary';
import cData from '../../../reducedData.json';
import FuzySearch from '../../fuzySearch/fuzySearch';
import { Checkbox } from 'antd';
import { getPopupContent } from './Popup';
import 'leaflet/dist/leaflet.css';
import './LtcMap.scss';
import useInterval from './useInterval';
import trans from '../../../translations.json';
import Loading from '../../loading/loading';
import { highlightSearchResult } from './highlightSearchResult';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import L from 'leaflet';
import LTCdata from '../../../LTCdata.json';
import SearchResultsDropdown from '../../search/searchResultDropdown';

const svgHomeInOutbreak = `<svg width="20" height="30" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.14227 13.6076C7.90023 14.3655 8.92825 14.7913 10.0002 14.7913C10.5309 14.7913 11.0565 14.6868 11.5468 14.4837C12.0372 14.2806 12.4828 13.9829 12.8581 13.6076C13.2334 13.2323 13.5311 12.7867 13.7342 12.2964C13.9373 11.806 14.0418 11.2804 14.0418 10.7497C14.0418 9.67776 13.616 8.64974 12.8581 7.89179C12.1001 7.13383 11.0721 6.70801 10.0002 6.70801C8.92825 6.70801 7.90023 7.13383 7.14227 7.89179C6.38431 8.64974 5.9585 9.67776 5.9585 10.7497C5.9585 11.8216 6.38431 12.8496 7.14227 13.6076ZM10.0002 28.4085C9.98483 28.3908 9.96905 28.3725 9.95286 28.3537C9.68451 28.0422 9.30031 27.5881 8.83891 27.0196C7.91567 25.882 6.68549 24.2892 5.45631 22.4674C4.22617 20.6442 3.00319 18.6005 2.08928 16.5606C1.17242 14.514 0.583496 12.5079 0.583496 10.7497C0.583496 8.25222 1.57561 5.85705 3.34157 4.09109C5.10754 2.32512 7.50271 1.33301 10.0002 1.33301C12.4976 1.33301 14.8928 2.32512 16.6588 4.09109C18.4247 5.85705 19.4168 8.25222 19.4168 10.7497C19.4168 12.5079 18.8279 14.514 17.9111 16.5606C16.9971 18.6005 15.7742 20.6442 14.544 22.4674C13.3148 24.2892 12.0847 25.882 11.1614 27.0196C10.7 27.5881 10.3158 28.0422 10.0475 28.3537C10.0313 28.3725 10.0155 28.3908 10.0002 28.4085Z" fill="#D0908C" stroke="#A86965"/>
</svg>`;
const svgHomeNotInOutbreak = `<svg width="20" height="30" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0002 0.833008C7.3701 0.833008 4.84776 1.8778 2.98802 3.73753C1.12828 5.59727 0.0834961 8.11961 0.0834961 10.7497C0.0834961 18.1872 10.0002 29.1663 10.0002 29.1663C10.0002 29.1663 19.9168 18.1872 19.9168 10.7497C19.9168 8.11961 18.872 5.59727 17.0123 3.73753C15.1526 1.8778 12.6302 0.833008 10.0002 0.833008Z" fill="#314F7C"/>
<path d="M15 7.00714L13.9929 6L10 9.99286L6.00714 6L5 7.00714L8.99286 11L5 14.9929L6.00714 16L10 12.0071L13.9929 16L15 14.9929L11.0071 11L15 7.00714Z" fill="white"/>
</svg>
`;

const iconHomeInOutbreak = L.divIcon({
  html: svgHomeInOutbreak,
  iconSize: [10, 10],
  iconAnchor: [10, 10],
});

const iconHomeNotInOutbreak = L.divIcon({
  html: svgHomeNotInOutbreak,
  iconSize: [10, 10],
  iconAnchor: [10, 10],
});

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const citiesPHU = Object.keys(cData.dataCitiesAndLTC).reduce(
  (sum, currCITY) => {
    return sum.concat(
      cData.dataCitiesAndLTC[currCITY].map((city) => {
        return {
          city_name: currCITY,
          phu_name: city,
        };
      }),
    );
  },
  [],
);

// const highestPhu = Object.values({ ...cData.dataPHU }).sort(
//   (a, b) => b[dict.PHU_pop] - a[dict.PHU_pop],
// )[0];

//console.log('highestPhu', highestPhu);

//Fsa disabled
// const fsaArr = false;
// const fsaArr = Object.keys(cData.dataFSA).reduce((sum, currFsa) => {
//   if (
//     currFsa === 'maxTotal' ||
//     currFsa === 'maxCapita' ||
//     currFsa === 'Unknown FSA'
//   ) {
//     return sum;
//   }

//   return sum.concat([{ [dict.FSA_name]: currFsa }]);
// }, []);

const defaultMapCfg = {
  lat: 44.61,
  lng: -79.42,
  zoom: 6,
};

let markers = {};
let cityCenterMarker = undefined;

const mapColors = {
  [dict.hospitalized]: {
    start: [234, 202, 171],
    end: [182, 104, 42],
  },
  [dict.inICU]: {
    start: [228, 190, 188],
    end: [164, 73, 67],
  },
  [dict.bedsTaken]: {
    start: [184, 217, 180],
    end: [79, 140, 71],
  },
};

const searchOpts = {
  [dict.phu]: {
    includeMatches: true,
    keys: ['city_name', 'phu_name'],
  },
  [dict.fsa]: {
    includeMatches: true,
    keys: [dict.FSA_name],
    findAllMatches: true,
  },
};
const LtcMap = (props) => {
  /**
   * A bit of badly written terminology used in this component
   * =====================
   * isPerCapita -> true/false. Whether the map is in a /100k view or not.
   *
   * metric -> dict.NotResolved/dict.resolved/dict.deaths/dict.totaCases. What the map measures the virus by.
   *
   * mode -> dict.phu/dict.fsa. Set of geometric polygons describing the area of effect.
   */

  // keep track of how to display and calculate the map
  const [isPerCapita, setIsPerCapita] = useState(true);
  const [metric, setMetric] = useState(dict.hospitalized);
  const [mode, setMode] = useState(dict.phu); // either phu or fsa
  const [showHomeInOutbreak, setShowHomeInOutbreak] = useState(true);
  const [showHomeNotInOutbreak, setShowHomeNotInOutbreak] = useState(
    true,
  );
  //number of results to show in dropdown menu
  const [numOfRes] = useState(12);
  // gatekeepers that clean input before actually sending it to their actual values
  const [
    intentionToTransferMode,
    setIntentionToTransferMode,
  ] = useState();
  const [
    intentionToTransferMetric,
    // setIntentionToTransferMetric,
  ] = useState(dict.hospitalized);

  // store geojson bounds for both maps
  const [bounds, setBounds] = useState({});
  const [postalBounds, setPostalBounds] = useState({});

  // if the fsa geojson has finished downloading
  const [fsaReady, setFsaReady] = useState(false);

  // display
  const [mapColor, setMapColor] = useState(
    mapColors[dict.hospitalized],
  );
  const [showCallout, setShowCallout] = useState(false);

  // search
  const [searchResults, setSearchResults] = useState([]);
  const [waitingForSearch, setWaitingForSearch] = useState(false);

  // overwriting fuzzy search query
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQueryTime, setSearchQueryTime] = useState(+new Date());

  // leaflet
  const mapRef = createRef();

  const resetMapView = () => {
    mapRef.current.leafletElement.flyTo(
      [defaultMapCfg.lat, defaultMapCfg.lng],
      defaultMapCfg.zoom,
      { animate: true, duration: 1 },
    );
  };
  /**
   * Gets the shade that a phu feature should be filled with based on current state.
   * @param {string} featureName Full name of Feature (phu/fsa)
   */
  const getShade = (featureName) => {
    let perc;
    const capitaMode = isPerCapita ? 'capita' : 'total';
    if (mode === dict.phu) {
      // PHU
      const phuData = cData.dataPHU[featureName];
      // console.log('cData', cData);
      perc = phuData[metric]
        ? phuData[metric] /
          cData.maxStats[dict.phu][capitaMode][metric]
        : [];

      //console.log('capitaMode', capitaMode);

      if (isPerCapita) {
        perc /= phuData[dict.PHU_pop];
      }
    } else {
      // FSA
      const fsaData = cData.dataFSA[featureName];

      try {
        perc =
          fsaData[isPerCapita ? dict.FSA_per_100k : dict.FSA_active] /
          cData.maxStats[dict.fsa][capitaMode][metric];
      } catch (err) {
        perc = 0;
      }
    }

    return '#F2F2F2';
  };
  const onClickSearchResult = (phu_name) => {
    setSearchResults([]);
    setSearchQuery(phu_name);
    setSearchQueryTime(+Date.now());
    selectZone(phu_name);
  };

  const hideDropdown = () => {
    setSearchResults([]);
  };
  //sync colors
  useEffect(() => {
    setMapColor(mapColors[metric]);
  }, [metric]);

  useEffect(() => {
    if (
      intentionToTransferMetric !== dict.NotResolved &&
      (intentionToTransferMode === dict.fsa || mode === dict.fsa)
    ) {
      // redirect to phu mode
      setMode(dict.phu);
      setMetric(intentionToTransferMetric);

      resetMapView();

      // clear search in fuzzysearch to prevent loop
      setSearchQuery('');
      setSearchQueryTime(+new Date());

      // since search got cleared, remove results as well
      setSearchResults([]);

      //show callout
      setShowCallout(true);
    } else {
      setShowCallout(false);
      if (intentionToTransferMetric)
        setMetric(intentionToTransferMetric);
    }
  }, [intentionToTransferMetric, intentionToTransferMode]);

  const geoJSONStyle = (feature) => {
    let featureName;

    if (mode === dict.phu) {
      featureName = feature.properties[dict.PHU_NAME_ENG];
    } else {
      featureName = feature.properties[dict.FSA_ID];
    }
    const config = {
      color: '#cccccc',
      weight: 1,
      fillOpacity: 1,
      fillColor: getShade(featureName),
    };

    return config;
  };

  // dynamically change the popup content based on if it is per capita or not
  useEffect(() => {
    if (mode === dict.phu) {
      Object.keys(bounds).map((phu) => {
        bounds[phu].setPopupContent(
          getPopupContent(phu, props.lang, mode, isPerCapita),
        );
      });
    }
  }, [isPerCapita]);

  // if trying to transfer to fsa, but the data has not been downloaded,
  // keep polling until it's possible
  useInterval(
    () => {
      if (intentionToTransferMode === dict.fsa && !fsaReady) {
        return;
      } else {
        setMode(intentionToTransferMode);
        setIntentionToTransferMode();
      }
    },
    intentionToTransferMode ? 500 : null,
  );

  /**
   * Runs for every feature on the map
   */
  const onEachFeature = (feature, layer) => {
    let featureName;

    if (mode === dict.phu) {
      featureName = feature.properties[dict.PHU_NAME_ENG];
    } else {
      featureName = feature.properties[dict.FSA_ID];
    }

    // append the bounds of the phu to state
    if (mode === dict.phu) {
      setBounds((oldBounds) => {
        return { ...oldBounds, [featureName]: layer };
      });
    } else {
      setPostalBounds((oldBounds) => {
        return { ...oldBounds, [featureName]: layer };
      });
    }

    const popupContent = getPopupContent(
      featureName,
      props.lang,
      mode,
      isPerCapita,
    );
    layer.bindPopup(popupContent, { maxHeight: 'none' });
  };

  /**
   * Zooms in and map autofits to a GEOJSON object
   * @param {string} featureName PHU to zoom to
   */

  const selectZone = (featureName) => {
    if (!Object.keys(cData.dataCitiesAndLTC).includes(featureName)) {
      const map = mapRef.current.leafletElement;
      let latLngs = [markers[featureName].leafletElement.getLatLng()];
      map.fitBounds(L.latLngBounds(latLngs).pad(0.85));
      map.setZoom(13);
      setTimeout(() => {
        markers[featureName].leafletElement.openPopup();
      }, 500);
    } else {
      let cityPopupContent = `<Popup>
      <b>${featureName}</b>
      </Popup>`;
      const map = mapRef.current.leafletElement;
      let group = new L.featureGroup(
        Object.values(cData.dataCitiesAndLTC[featureName]).map(
          (item) => markers[item].leafletElement,
        ),
      );
      if (cityCenterMarker) {
        map.removeLayer(cityCenterMarker);
      }
      let cityBounds = group.getBounds();
      let cityMarker = cityBounds._northEast;
      let cityMarker2 = cityBounds._southWest;
      cityCenterMarker = L.marker({
        lat: (cityMarker.lat + cityMarker2.lat) / 2,
        lng: (cityMarker.lng + cityMarker2.lng) / 2,
      });
      map.fitBounds(cityBounds);
      map.setZoom(13);
      setTimeout(() => {
        cityCenterMarker
          .addTo(map)
          .bindPopup(cityPopupContent)
          .openPopup();
      }, 500);
    }
  };

  /**
   * Sets search data state after Fuze returns a new search
   */
  const searchResultsCallback = (query, results) => {
    if (query.length < 3) {
      if (searchResults !== []) {
        setSearchResults([]);
      }
      return;
    }

    setWaitingForSearch(false);

    setSearchResults(() => {
      return results
        ? results.slice(0, Math.min(results.length, numOfRes))
        : [];
    });
  };

  const SearchResultsDropdown2 = () => {
    const onMouseDown = (item) => {
      const featureName =
        mode === dict.phu
          ? item.item.phu_name
          : item.item[dict.FSA_name];

      // remove dropdown
      setSearchResults([]);

      // set map to zoom to zone
      selectZone(featureName);

      // push the featurename to fuzzy search
      setSearchQuery(featureName);
      setSearchQueryTime(+new Date());
    };

    const formatResult =
      mode === dict.phu
        ? (item) => {
            const phuName = item.item.phu_name;
            const cityName = item.item.city_name;
            const connector =
              props.lang === 'en' ? 'in ' : 'in ' ? "en'" : 'en ';

            return (
              <>
                {phuName} {connector}
                <b>
                  {highlightSearchResult(
                    cityName,
                    item.matches[0].indices,
                  )}
                </b>
              </>
            );
          }
        : (item) => {
            return (
              <b style={{ width: '100%' }}>
                {' '}
                {item.item[dict.FSA_name]}{' '}
              </b>
            );
          };

    return (
      (waitingForSearch || searchResults.length !== 0) && (
        <ul id="viz-search-result-dropdown" role="toolbar">
          {waitingForSearch ? (
            <li className="search-loader-container">
              <div className="loader search-loader" />{' '}
              <span>Loading...</span>
            </li>
          ) : (
            searchResults.length !== 0 &&
            searchResults.map((item, idx) => {
              return (
                <li>
                  <button
                    aria-setsize="4"
                    aria-posinset={idx}
                    onMouseDown={() => {
                      onMouseDown(item);
                    }}
                    key={idx}
                    style={{ cursor: 'pointer' }}
                  >
                    {formatResult(item)}
                  </button>
                </li>
              );
            })
          )}
        </ul>
      )
    );
  };

  let message = '';
  function getMessage(metric) {
    if (metric === dict.hospitalized) {
      message = trans.heatmap.searchNew[props.lang];
    } else if (metric === dict.inICU) {
      message = trans.heatmap.searchNew[props.lang];
    } else if (metric === dict.bedsTaken) {
      message = trans.heatmap.searchNew[props.lang];
    }

    return message;
  }

  return (
    <div
      id="viz-region-heatmap"
      className="ontario-row ontario-margin-bottom-32-!"
    >
      {props.showSidebar ? (
        <div
          id="compare-chart-controls"
          className="ontario-columns ontario-medium-4 ontario-small-12 ontario-margin-bottom-8-!"
        >
          {citiesPHU.length && (
            <>
              <div className="ontario-margin-bottom-8-!">
                <div className="ontario-label ontario-margin-bottom-8-!">
                  {trans.heatmap.showByLTC[props.lang]}
                </div>
              </div>
              <FuzySearch
                onBlur={() =>
                  setTimeout(() => {
                    setSearchResults([]);
                  }, 200)
                }
                searchQuery={searchQuery}
                searchQueryTime={searchQueryTime}
                searchResultsCallback={searchResultsCallback}
                data={citiesPHU}
                minSearchLength={3}
                searchSettings={searchOpts[mode]}
                searchResultsStartCallback={() => {
                  setWaitingForSearch(true);
                }}
                searchLabel={trans.heatmap.cityOrLTC[props.lang]}
                class="ontario-label"
              />
            </>
          )}
          <SearchResultsDropdown
            numOfRes={numOfRes - 1}
            results={searchResults}
            handleOnClick={onClickSearchResult}
            hideDropdown={hideDropdown}
            cityFirst={true}
          />
          <div id="cviz-ltcMap-legend-container">
            <div class="ontario-label ontario-margin-bottom-8-!">
              {trans.LtcMap.Legend[props.lang]}
            </div>
            <div className="cviz-ltcMap-legend-item-container">
              <div id="cviz-ltcMap-legend-numberOfHomes-icon"></div>
              <p>{trans.LtcMap.numberHomes[props.lang]}</p>
            </div>
            <div className="cviz-ltcMap-legend-item-container">
              <div
                dangerouslySetInnerHTML={{
                  __html: svgHomeInOutbreak,
                }}
              ></div>
              <p>{trans.LtcMap.popupInOutbreak[props.lang]}</p>
            </div>
            <div className="cviz-ltcMap-legend-item-container">
              <div
                dangerouslySetInnerHTML={{
                  __html: svgHomeNotInOutbreak,
                }}
              ></div>
              <p>{trans.LtcMap.popupNotInOutbreak[props.lang]}</p>
            </div>
          </div>
        </div>
      ) : null}
      <div
        id="regionalMap"
        className="ontario-columns ontario-medium-8 ontario-small-12"
      >
        <Map
          aria-hidden="true"
          attributionControl={false}
          center={[defaultMapCfg.lat, defaultMapCfg.lng]}
          zoom={defaultMapCfg.zoom}
          minZoom={4}
          maxZoom={18}
          scrollWheelZoom={false}
          ref={mapRef}
          className="leaflet-container"
          closePopupOnClick={true}
          style={{ background: '#fff' }}
        >
          {mode === dict.phu && !intentionToTransferMode && (
            <GeoJSON
              data={phuBoundaries}
              style={geoJSONStyle}
              onEachFeature={onEachFeature}
            />
          )}

          {intentionToTransferMode && (
            <div className="covid-loader">
              <Loading />
            </div>
          )}

          {/* FSA Data */}
          {mode === dict.fsa && !intentionToTransferMode && (
            <GeoJSON
              data={postalBounds}
              style={geoJSONStyle}
              onEachFeature={onEachFeature}
            />
          )}
          <MarkerClusterGroup
            maxClusterRadius={30}
            showCoverageOnHover={false}
          >
            {LTCdata.data.map((item, i) => {
              let condition = true;
              if (showHomeInOutbreak && showHomeNotInOutbreak) {
                condition = true;
              } else if (
                !showHomeInOutbreak &&
                !showHomeNotInOutbreak
              ) {
                condition = false;
              } else if (
                showHomeInOutbreak &&
                !showHomeNotInOutbreak
              ) {
                condition =
                  cData.dataLTCactive[item.LTC_name] &&
                  cData.dataLTCactive[item.LTC_name][
                    'ï»¿Report_Data_Extracted'
                  ] === cData.dataLTCactive.ReportedDate;
              } else if (
                !showHomeInOutbreak &&
                showHomeNotInOutbreak
              ) {
                condition = !cData.dataLTCactive[item.LTC_name];
              }

              if (condition) {
                return (
                  <Marker
                    key={i}
                    position={item.LTC_coordinates}
                    ref={(ref) => (markers[item.LTC_name] = ref)}
                    icon={
                      cData.dataLTCactive[item.LTC_name] &&
                      cData.dataLTCactive[item.LTC_name][
                        'ï»¿Report_Data_Extracted'
                      ] === cData.dataLTCactive.ReportedDate
                        ? iconHomeInOutbreak
                        : iconHomeNotInOutbreak
                    }
                  >
                    <Popup>
                      <b>{item.LTC_name}</b>
                      <span className="cviz-ltcMap-status">
                        <div
                          className={
                            cData.dataLTCactive[item.LTC_name] &&
                            cData.dataLTCactive[item.LTC_name][
                              'ï»¿Report_Data_Extracted'
                            ] === cData.dataLTCactive.ReportedDate
                              ? 'cviz-ltcMap-status-icon-inOutbreak'
                              : 'cviz-ltcMap-status-icon-notInOutbreak'
                          }
                        ></div>
                        <p>
                          {cData.dataLTCactive[item.LTC_name] &&
                          cData.dataLTCactive[item.LTC_name][
                            'ï»¿Report_Data_Extracted'
                          ] === cData.dataLTCactive.ReportedDate
                            ? trans.LtcMap.popupInOutbreak[props.lang]
                            : trans.LtcMap.popupNotInOutbreak[
                                props.lang
                              ]}
                        </p>
                      </span>
                      {cData.dataLTCactive[item.LTC_name] &&
                      cData.dataLTCactive[item.LTC_name][
                        'ï»¿Report_Data_Extracted'
                      ] === cData.dataLTCactive.ReportedDate ? (
                        <>
                          <p>
                            {trans.LtcMap.Beds[props.lang] +
                              ': ' +
                              cData.dataLTCactive[item.LTC_name].Beds}
                          </p>
                          <p>
                            {trans.overview.total[props.lang] +
                              ': ' +
                              cData.dataLTCactive[item.LTC_name]
                                .cases}
                          </p>
                          <p style={{ marginLeft: '25px' }}>
                            {trans.LtcMap.Resident[props.lang] +
                              ': ' +
                              cData.dataLTCactive[item.LTC_name]
                                .Total_LTC_Resident_Cases}
                          </p>
                          <p style={{ marginLeft: '25px' }}>
                            {trans.LtcMap.Staff[props.lang] +
                              ': ' +
                              cData.dataLTCactive[item.LTC_name]
                                .Total_LTC_HCW_Cases}
                          </p>
                          <p>
                            {trans.overview.deaths[props.lang] +
                              ': ' +
                              cData.dataLTCactive[item.LTC_name]
                                .Total_LTC_Resident_Deaths}
                          </p>
                        </>
                      ) : (
                        cData.dataLTCactive[item.LTC_name] && (
                          <>
                            <p>
                              {trans.LtcMap.Beds[props.lang] +
                                ': ' +
                                cData.dataLTCactive[item.LTC_name]
                                  .Beds}
                            </p>
                            <p>
                              {trans.overview.deaths[props.lang] +
                                ': ' +
                                cData.dataLTCactive[item.LTC_name]
                                  .Total_LTC_Resident_Deaths}
                            </p>
                          </>
                        )
                      )}
                    </Popup>
                  </Marker>
                );
              }
            })}
          </MarkerClusterGroup>
        </Map>
        <Checkbox
          className="cviz-graph-checkboxes--1"
          checked={showHomeInOutbreak}
          onClick={() =>
            setShowHomeInOutbreak(showHomeInOutbreak ? false : true)
          }
        >
          {trans.LtcMap.popupInOutbreak[props.lang]}
        </Checkbox>
        <Checkbox
          className="cviz-graph-checkboxes--16"
          checked={showHomeNotInOutbreak}
          onClick={() =>
            setShowHomeNotInOutbreak(
              showHomeNotInOutbreak ? false : true,
            )
          }
        >
          {trans.LtcMap.popupNotInOutbreak[props.lang]}
        </Checkbox>
      </div>
    </div>
  );
};

export default LtcMap;
